import React from 'react';
import { ShareOpportunitySalesType, ShareOpportunityVoidsType } from 'utils/types';
import ShareChart from 'components/Charts/Pie';
import BaseChartWidget from 'components/Charts/Widgets/BaseChartWidget';

interface Props {
  globalFilter: any;
  portfolio?: boolean;
}

const ShareOpportunityChartWidget: React.FC<Props> = ({ globalFilter, portfolio }) => {
  return (
    <BaseChartWidget
      defaultType={ShareOpportunitySalesType}
      title="Share"
      types={[ShareOpportunitySalesType, ShareOpportunityVoidsType]}
    >
      {(clientId, type) => (
        <ShareChart
          type={type}
          clientID={clientId}
          globalFilter={globalFilter}
          portfolio={portfolio}
        />
      )}
    </BaseChartWidget>
  );
};

export default ShareOpportunityChartWidget;
